import React, { useState } from 'react';
import './DeleteConfirmationModal.css';

/**
 * Shared across products, categories and subcategories, so the noun is a prop.
 * `productName` is kept as the name prop because both existing call sites use
 * it; `itemType` defaults to "product" so nothing changes for them.
 * `title`, `message`, `reasonLabel` and `confirmLabel` override the wording — products are
 * "removed from the shop" rather than deleted (see RemovedProductsManagement).
 */
const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, productName, itemType = 'product',
                                   title = 'Confirm Deletion', message, reasonLabel = 'Reason for Deletion',
                                   confirmLabel = 'Confirm Delete' }) => {
  const [reason, setReason] = useState('');
  // Field-level validation, not a notification: the message belongs next to the
  // input it's about, announced with it, rather than in a toast across the screen.
  const [error, setError] = useState('');

  if (!isOpen) {
    return null;
  }

  const handleConfirm = () => {
    if (!reason.trim()) {
      setError('Please give a reason first.');
      return;
    }
    setError('');
    onConfirm(reason);
  };

  return (
    <div className="delete-modal-overlay" onClick={onClose}>
      <div className="delete-modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>{title}</h2>
        <p>
          {message || <>Are you sure you want to delete the {itemType}: <strong>{productName}</strong>?</>}
        </p>
        <div className="form-group">
          <label htmlFor="deleteReason">{reasonLabel}</label>
          <textarea
            id="deleteReason"
            value={reason}
            onChange={(e) => { setReason(e.target.value); if (error) setError(''); }}
            placeholder="Please provide a reason..."
            rows="3"
            aria-invalid={error ? 'true' : undefined}
            aria-describedby={error ? 'deleteReasonError' : undefined}
          />
          {error && (
            <p id="deleteReasonError" className="delete-modal-error" role="alert">
              {error}
            </p>
          )}
        </div>
        <div className="modal-actions">
          <button onClick={onClose} className="btn-cancel">
            Cancel
          </button>
          <button onClick={handleConfirm} className="btn-confirm-delete">
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;